"use strict";
/*
 * Dyna node network - Dyna Node server
 * (c) Anel development - http://www.anel.co
 * License: MIT (http://www.opensource.org/licenses/mit-license.php)
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
// help: https://github.com/socketio/engine.io
var http = require("http");
var engineIo = require("engine.io");
var dyna_loops_1 = require("dyna-loops");
var dyna_interfaces_1 = require("dyna-interfaces");
var dyna_timeout_1 = require("dyna-timeout");
var DynaNodeConnection_1 = require("./DynaNodeConnection");
var DynaNodeServerAPI_1 = require("./DynaNodeServerAPI");
var DynaNodeAddress_1 = require("../DynaNodeAddress/DynaNodeAddress");
var consoleStringify_1 = require("../utils/consoleStringify");
var defaultSettings_1 = require("../defaultSettings");
var DynaNodeServer = /** @class */ (function () {
    function DynaNodeServer(_config) {
        var _this = this;
        this._config = _config;
        this._connectionsTimeoutHandler = new dyna_timeout_1.DynaTimeout();
        this._connections = {};
        this.getServerAddresses = function () {
            return new Array()
                .concat(_this._config.addresses.internal, _this._config.addresses.external || "", _this._config.addresses.externals || [])
                .filter(Boolean);
        };
        this._postMessage = function (message, cbCompleted) {
            if (message.replyOf) {
                message.from = message.replyOf.to;
            }
            else {
                message.from = _this._internalServerDNAddress.address;
            }
            _this._dispatch(message, cbCompleted);
        };
        this._changeConnectionIdForService = function (currentConnectionId, newConnectionId) {
            var connection = _this._connections[currentConnectionId];
            if (!connection) {
                console.error("DynaNodeServer: _changeConnectionIdForService: there are no connections with connectionId [" + currentConnectionId + "]. New connectionId: [" + newConnectionId + "]");
                return;
            }
            var inactiveConnectionTimeoutInMinutes = _this._config.connectionIds
                && _this._config.connectionIds[newConnectionId]
                && _this._config.connectionIds[newConnectionId].inactiveConnectionTimeoutInMinutes
                || 0;
            // update the _connections object
            delete _this._connections[currentConnectionId];
            _this._connections[newConnectionId] = connection;
            connection._setConnectionId(newConnectionId);
            // if the connection currently has inactiveConnectionTimeoutInMinutes remove it
            if (connection.inactiveConnectionTimeoutInMinutes) {
                _this._connectionsTimeoutHandler.cancel(currentConnectionId);
            }
            // if this new connectionId in the config has inactiveConnectionTimeoutInMinutes set it and add it in the _connectionsTimeoutHandler
            connection.inactiveConnectionTimeoutInMinutes = inactiveConnectionTimeoutInMinutes;
            if (connection.inactiveConnectionTimeoutInMinutes) {
                _this._connectionsTimeoutHandler.add(newConnectionId, inactiveConnectionTimeoutInMinutes * 60 * 1000, function () {
                    _this._closeConnection(newConnectionId);
                });
            }
        };
        this._config = __assign({ inactiveConnectionTimeoutInMinutes: 60, wsPingTimeout: 5000, wsPingInterval: 10000, maxMessagePacketSize: defaultSettings_1.DEFAULT_maxMessagePacketSize, firewallValidateIncomingConnection: function () { return Promise.resolve(); }, firewallValidateIncomingMessage: function () { return Promise.resolve(); } }, this._config);
        this._internalServerDNAddress = new DynaNodeAddress_1.DynaNodeAddress(this._config.addresses.internal);
        this._externalServerDNAddresses =
            new Array()
                .concat(this._config.addresses.external || "", this._config.addresses.externals || [])
                .filter(Boolean)
                .map(function (address) { return new DynaNodeAddress_1.DynaNodeAddress(address); });
        this._allServerAddresses =
            new Array()
                .concat(this._internalServerDNAddress, this._externalServerDNAddresses)
                .map(function (address) { return address.address; });
        this._api = new DynaNodeServerAPI_1.DynaNodeServerAPI({
            postMessage: this._postMessage,
            connectionIds: this._config.connectionIds,
            getStats: function () { return _this.stats; },
            getServerAddresses: this.getServerAddresses,
            changeConnectionIdForService: this._changeConnectionIdForService,
        });
    }
    DynaNodeServer.prototype.start = function (appExpress) {
        return this._createHttpAndWSServer(appExpress);
    };
    Object.defineProperty(DynaNodeServer.prototype, "stats", {
        get: function () {
            return {
                time: (new Date()).toISOString(),
                connections: Object.keys(this._connections),
                internalDNAddress: this._internalServerDNAddress.address,
                externalDNAddresses: this._externalServerDNAddresses.map(function (dnaAddress) { return dnaAddress.address; }),
                memory: process.memoryUsage(),
            };
        },
        enumerable: true,
        configurable: true
    });
    DynaNodeServer.prototype._createHttpAndWSServer = function (appExpress) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this._wsServer) {
                reject({
                    section: 'DynaNodeServer/start',
                    code: 21112507,
                    message: 'IWSServer is already started',
                    data: { config: _this._config },
                });
                return;
            }
            try {
                _this._httpServer = http.createServer(appExpress);
                _this._wsServer = engineIo.attach(_this._httpServer, {
                    pingTimeout: _this._config.wsPingTimeout,
                    pingInterval: _this._config.wsPingInterval,
                    maxHttpBufferSize: _this._config.maxMessagePacketSize,
                });
                _this._httpServer.listen(_this._internalServerDNAddress.server.port);
                _this._wsServer.on('connection', function (entityIOSocket) { return _this._handleNewWSConnection(entityIOSocket); });
                resolve();
            }
            catch (error) {
                reject({
                    section: 'DynaNodeServer/start',
                    code: 21172507,
                    message: "General error: Cannot create and open the server on this address " + _this._internalServerDNAddress.address,
                    data: {
                        addresses: {
                            internal: _this._internalServerDNAddress.address,
                            externals: _this._externalServerDNAddresses.map(function (dnaAddress) { return dnaAddress.address; }),
                        },
                    },
                    error: error,
                });
            }
        });
    };
    DynaNodeServer.prototype._handleNewWSConnection = function (entityIOSocket) {
        var _this = this;
        var connection = new DynaNodeConnection_1.DynaNodeConnection({
            entityIOSocket: entityIOSocket,
            onMessage: function (message) { return _this._dispatch(message); },
            onConnectionClose: function () {
                if (_this._connections[connection.connectionId] !== connection)
                    return; // exit, the current connection in _connections is a restored one; for more read at the bottom the #0248290486 note
                // todo: debug code, remove this if Statement, is only for the Task 1780
                if (_this._connections[connection.connectionId] && connection.connectionId.indexOf('service') > -1) {
                    console.warn("DynaNodeServer: internal warn. Dyna Node Server: 1904070907 Connection lost with service with id [" + connection.connectionId + "] Note! This is not an error is a temporary debug message for the Task 1780.");
                }
                if (!_this._connections[connection.connectionId]) {
                    console.error('DynaNodeServer: internal error 1912260815, connection lost of a connection id that does not exists', connection.connectionId);
                }
                delete _this._connections[connection.connectionId];
                _this._connectionsTimeoutHandler.cancel(connection.connectionId);
            },
            onError: function (error) { return console.error('DynaNodeServer: Client connection error: 1904070900: ', consoleStringify_1.consoleStringify(error)); },
        });
        connection.inactiveConnectionTimeoutInMinutes = this._config.inactiveConnectionTimeoutInMinutes;
        if (this._config.firewallValidateIncomingConnection) {
            this._config.firewallValidateIncomingConnection(connection)
                .then(function () {
                _this._connections[connection.connectionId] = connection;
                if (connection.inactiveConnectionTimeoutInMinutes) {
                    _this._connectionsTimeoutHandler.add(connection.connectionId, connection.inactiveConnectionTimeoutInMinutes * 60 * 1000, function () {
                        _this._closeConnection(connection.connectionId);
                    });
                }
            })
                .catch(function () { return undefined; });
        }
    };
    DynaNodeServer.prototype.stop = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) {
                        if (!_this._wsServer) {
                            resolve();
                            return;
                        }
                        _this._wsServer.close();
                        _this._wsServer = null;
                        _this._httpServer.close(function () { return resolve(); });
                    })];
            });
        });
    };
    // this is for internal user... is used from Server's method where from is the address of the server only
    DynaNodeServer.prototype._postMessageOnBehalfOfServer = function (message, cbCompleted) {
        message.from = message.to.split('@')[1];
        this._dispatch(message, cbCompleted);
    };
    DynaNodeServer.prototype._dispatch = function (message, cbCompleted) {
        var _this = this;
        var fromAddress = new DynaNodeAddress_1.DynaNodeAddress(message.from);
        var toAddress = new DynaNodeAddress_1.DynaNodeAddress(message.to);
        var fromConnection = this._connections[fromAddress.connectionId];
        var toConnection = this._connections[toAddress.connectionId];
        if (this._config._debug_consoleDispatches) {
            console.log('DynaNodeServer: info: dispatch from: ' + message.from + ' to: ' + message.to + ' command: ' + message.command, consoleStringify_1.consoleStringify(message.viewSecure));
        }
        fromConnection && fromConnection.inactiveConnectionTimeoutInMinutes && this._connectionsTimeoutHandler.update(fromAddress.connectionId);
        toConnection && toConnection.inactiveConnectionTimeoutInMinutes && this._connectionsTimeoutHandler.update(toAddress.connectionId);
        // If the message is for this server handle it and exit
        Promise.resolve()
            .then(function () {
            if (_this._config.firewallValidateIncomingMessage)
                return _this._config.firewallValidateIncomingMessage(fromConnection, message);
            return Promise.resolve();
        })
            .then(function () {
            // If the message is for this server handle it and exit
            if (_this._allServerAddresses.includes(toAddress.address)) {
                _this._api.processMessage(message);
                return;
            }
            // is the toConnection id exists on this server send it through the toConnection
            if (toConnection) {
                message._addTrace('DynaNode/Server/DISPATCH_SUCCESS', "DynaNodeServer: Dispatch the message to connection", _this._traceData);
                toConnection.send(message, cbCompleted);
                return;
            }
            // reply to recipient doesn't not exist,
            // if the sender is not in this server... because this is the case that the sender also doesn't exist anymore!
            if (!_this._allServerAddresses.includes(message.from)) {
                var replyError404Message = message.reply({
                    command: "error/dyna-node/404/101",
                    data: {
                        code: 404.101,
                        section: "DynaNodeServer/dispatch",
                        errorType: dyna_interfaces_1.EErrorType.USER,
                        message: "The recipient " + message.to + " does not exist here. The incoming message is at replyOf.",
                    },
                    updateReplyOfArgs: true,
                    updateReplyOfData: true,
                    updateReplyOfReplyOf: true,
                });
                message._addTrace('DynaNode/Server/DISPATCH_ERROR_404', "DynaNodeServer: Reply with 404 error", _this._traceData);
                _this._postMessageOnBehalfOfServer(replyError404Message);
            }
            else {
                console.warn('DynaNodeServer: Warn: 20552307 Dispatch: This message cannot be delivered because both Sender and Recipient does not exist anymore', consoleStringify_1.consoleStringify(message.viewSecure));
            }
        })
            .catch(function (error) {
            message._addTrace('DynaNode/Server/DISPATCH_ERROR_505', "DynaNodeServer: Reply with 505 error", _this._traceData);
            _this._postMessageOnBehalfOfServer(message.reply({
                command: "error/dyna-node/505",
                data: {
                    code: 1912241827,
                    section: 'DynaNodeServer/_dispatch',
                    message: 'General dispatch error',
                    error: error,
                },
            }));
        })
            .then(function () {
            cbCompleted && cbCompleted();
        });
    };
    Object.defineProperty(DynaNodeServer.prototype, "_traceData", {
        get: function () {
            return {
                dynaNodeServerName: this._config.name || '-no name-',
            };
        },
        enumerable: true,
        configurable: true
    });
    DynaNodeServer.prototype._closeConnection = function (connectionId) {
        var connection = this._connections[connectionId];
        if (connection)
            connection.close();
    };
    DynaNodeServer.prototype._closeAllConnections = function () {
        dyna_loops_1.default.values(this._connections).forEach(function (connection) {
            connection.close();
        });
    };
    DynaNodeServer.prototype._debug_dropAllConnections = function () {
        this._closeAllConnections();
    };
    return DynaNodeServer;
}());
exports.DynaNodeServer = DynaNodeServer;
console.debug('dyna-node debug version 234');
//# sourceMappingURL=DynaNodeServer.js.map